import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResizeService {
  private _isResizingSignal = signal<Record<string, boolean>>({});
  public isResizingSignal = this._isResizingSignal.asReadonly();

  public toggleResizingState(key: string, isResizing: boolean): void {
    this._isResizingSignal.update(currentState => ({
      ...currentState,
      [key]: isResizing
    }));
  }

  public resetResizingState(): void {
    this._isResizingSignal.update(currentState =>
      Object.fromEntries(
        Object.entries(currentState).map(([key]) => [key, false])
      ) as Record<string, boolean>
    );
  }
}
